// lib/strategyAuth.js — Phase 3B individual-account session state for
// the Stratégie module. Deliberately its OWN tiny store, separate from
// `identity.js`'s `adminAuth` (legacy shared-password admin panel) —
// a Stratégie session expiring must never log the admin out of the
// rest of the admin panel, and vice versa (see `strategyApi.js`).
const STORAGE_KEY = "rr_strategy_account";

let state = (() => {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    return raw ? JSON.parse(raw) : null;
  } catch {
    return null;
  }
})();

const listeners = new Set();

const notify = () => listeners.forEach((fn) => fn(state));

export const strategyAuth = {
  get: () => state,
  isLoggedIn: () => !!state,
  setSession: (payload) => {
    state = payload;
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(state));
    } catch {
      /* ignore quota errors — in-memory state still works */
    }
    notify();
  },
  setActiveCountry: (countryCode, role) => {
    if (!state) return;
    state = { ...state, activeCountryCode: countryCode, activeRole: role };
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(state));
    } catch {
      /* ignore */
    }
    notify();
  },
  clear: () => {
    state = null;
    try {
      localStorage.removeItem(STORAGE_KEY);
    } catch {
      /* ignore */
    }
    notify();
  },
  subscribe: (fn) => {
    listeners.add(fn);
    return () => listeners.delete(fn);
  },
};
